<template>
  <div>
    <Page
      :title="pageTitle"
      :showBack="true"
      :is-full-width="true"
      class="max-w-6xl mx-auto"
    >
      <div class="">
        <div>
          <div
            class="Polaris-Box"
            style="--pc-box-border-block-end:var(--p-border-divider);--pc-box-padding-inline-start-xs:var(--p-space-2);--pc-box-padding-inline-end-xs:var(--p-space-2)"
          >
            <ul role="tablist" class="Polaris-Tabs">
              <li
                v-for="(tab, index) of tabs"
                :key="index"
                class="Polaris-Tabs__TabContainer"
                role="presentation"
              >
                <router-link
                  role="tab"
                  :to="{ name: tab.routeName }"
                  type="button"
                  tabindex="0"
                  class="Polaris-Tabs__Tab"
                  exact-active-class="Polaris-Tabs__Tab--selected"
                  aria-selected="true"
                  aria-controls="all-customers-content-1"
                  aria-label="All customers"
                >
                  <span class="Polaris-Tabs__Title">{{ tab.label }}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div
            class="Polaris-Tabs__Panel"
            id="all-customers-content-1"
            role="tabpanel"
            aria-labelledby="all-customers-1"
            tabindex="-1"
          >
            <div class="Polaris-LegacyCard__Section">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from "../../../components/Common/Page.vue";
import crispNudgeMixin from "../../../Mixins/crispNudgeMixin";

export default {
  components: {
    Page
  },
  mixins: [crispNudgeMixin],
  data() {
    return {
      pageTitle: "Reviews",
      tabs: [
        {
          label: "Settings",
          routeName: "ReviewsSettings"
        },
        {
          label: "Scheduled",
          routeName: "ReviewsScheduled"
        },
        {
          label: "Message Logs",
          routeName: "ReviewsMessageLogs"
        }
      ]
    };
  },
  created() {
    const store = this.$store.getters.getStore;
    if (store.plan === "free" || store.plan === "limited_free") {
      this.onIntegrationPaywallBlocked({ name: "Integrations" });
      return;
    }

    if (this.$route.params.appName === "loox") {
      this.pageTitle = `Loox Integration`;
    }

    if (this.$route.params.appName === "judgeme") {
      this.pageTitle = `Judge.Me Integration`;
    }
    if (this.$route.params.appName === "trustedreviews") {
      this.pageTitle = `TrustReviews Integration`;
    }
  },
  methods: {
    onIntegrationPaywallBlocked(redirectRoute) {
      alert("please upgrade to paid plans for integrations");
      // this.showCrispNudge({
      //   key: "integration_paywall",
      //   text:
      //     "Integrations need a paid plan. Want help picking the smallest plan for your use case?",
      //   cooldownMs: 30 * 60 * 1000,
      //   scopeToRoute: true
      // });
      this.$router.push(redirectRoute);
    }
  }
};
</script>

<style lang="scss" scoped></style>
